import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';

class MarkOnHold extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = target;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    const { formUrl, csrfToken } = this.props;
    const data = this.state;

    return putRequest(
      formUrl,
      data,
      csrfToken,
    ).then(() => {
      window.location.reload();
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  render() {
    const {
      submitButtonText, triggerType, triggerText, triggerStyle, style,
    } = this.props;
    return (
      <ModalTrigger
        triggerText={triggerText}
        buttonStyles={`danger ${style} ${triggerStyle}`}
        submitButtonText={submitButtonText}
        headerTitle="Are you sure you want to put this project on hold?"
        handleSubmit={this.handleSubmit}
        triggerType={triggerType}
        idKey="mark-on-hold"
        cloneContent={false}
      >
        <p>Reason:</p>
        <textarea
          value={this.state.reason || ''}
          className="form-control"
          placeholder="Waiting on funding..."
          name="reason"
          id="reason"
          rows="4"
          onChange={this.handleInputChange}
        />
      </ModalTrigger>
    );
  }
}

MarkOnHold.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  triggerType: PropTypes.string,
  triggerText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  triggerStyle: PropTypes.string,
  style: PropTypes.string,
};

MarkOnHold.defaultProps = {
  submitButtonText: 'Yes, submit',
  triggerType: 'button',
  triggerText: 'Put On Hold',
  triggerStyle: '',
  style: '',
};

export default MarkOnHold;
